import type { 
  GetBookmarksData,
  GetBookmarksResponse,

  PostBookmarksData,
  PostBookmarksResponse
 } from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";

export function getBookmarkApiModule(affiliatesApi: AxiosInstance) {
  return {
    getBookmarks() {
      return affiliatesApi.get<GetBookmarksResponse>('/bookmarks');
    },
    addBookmarks(bookmarks: PostBookmarksData['body']) {
      return affiliatesApi.post<PostBookmarksResponse>('/bookmarks', { bookmarks });
    },
  }
}